import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "link"],
    ["clean"],
  ],
};

export const RichTextEditor = ({ value, onChange, testId }) => (
  <div data-testid={testId}>
    <ReactQuill theme="snow" value={value} onChange={onChange} modules={modules} />
  </div>
);
